import produce, { Draft } from "immer"
import { Rating } from "../common/types/rating"

type State = {
  rating: Rating
}

const rating = {
  state: {
    rating: {}
  } as State,
  reducers: {
    load: produce((draft: Draft<State>, payload: Rating) => {
      draft.rating = payload
    })
  }
}

export default rating